import React from "react";
import { BellRing } from "lucide-react";
import { CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ManualStockTriggerButton } from "../ManualStockTriggerButton";

interface TabHeaderProps {
  activeNotificationsCount: number;
  archivedNotificationsCount: number;
  viewMode: "active" | "archived";
  setViewMode: (value: "active" | "archived") => void;
}

const TabHeader = ({
  activeNotificationsCount,
  archivedNotificationsCount,
  viewMode,
  setViewMode
}: TabHeaderProps) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
      <CardTitle className="flex items-center">
        <BellRing className="mr-2 h-5 w-5" />
        Meldingoverzicht
      </CardTitle>
      
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
        <Tabs value={viewMode} onValueChange={(value) => setViewMode(value as "active" | "archived")}>
          <TabsList className="w-full sm:w-auto">
            <TabsTrigger value="active" className="text-xs sm:text-sm">
              Actief {activeNotificationsCount > 0 && <Badge className="ml-1 sm:ml-2 bg-primary text-xs">{activeNotificationsCount}</Badge>}
            </TabsTrigger>
            <TabsTrigger value="archived" className="text-xs sm:text-sm">
              Archief {archivedNotificationsCount > 0 && <Badge className="ml-1 sm:ml-2 bg-muted text-muted-foreground text-xs">{archivedNotificationsCount}</Badge>}
            </TabsTrigger>
          </TabsList>
        </Tabs>
        
        <ManualStockTriggerButton />
      </div>
    </div>
  );
};

export default TabHeader;
